import template from './delegationCard.html';
import controller from './delegationCard.controller';
import './delegationCard.scss';

let delegationCardComponent = {
  restrict: 'E',
  bindings: {
    isMobileApp: '<',
    employeeWithPower: '<',
    delegationInfo: '<',
    onCancel: '&',
    onEdit: '&',
    cardId: '@'
  },
  template,
  controller,
};

export default delegationCardComponent;



// WEBPACK FOOTER //
// ./client/app/components/delegationsList/delegationCard/delegationCard.component.js